import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Card } from '@material-ui/core';

const INVOICE_DATA = [
  { id: 1, content: 1 },
  { id: 2, content: 2 },
  { id: 3, content: 3 },
  { id: 4, content: 4 },
  { id: 5, content: 5 },
  { id: 6, content: 6 },
  { id: 7, content: 7 },
  { id: 8, content: 8 },
];

const SELECTED_DATA = [{ id: 9, content: 9 }, { id: 10, content: 10 }];

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.old, 1);

  destClone.splice(droppableDestination.old, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? '#1976d2' : '#2296f3',
  color: 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'lightblue' : 'white',
  padding: grid,
  width: 250,
});

const Map = () => {
  const [items, setItems] = useState(INVOICE_DATA);
  const [selected, setSelected] = useState(SELECTED_DATA);

  /**
   * A semi-generic way to handle multiple lists. Matches
   * the IDs of the droppable container to the names of the
   * source arrays stored in the state.
   */
  const id2List = {
    droppable: items,
    droppable2: selected,
  };

  const getList = id => id2List[id];

  const onDragEnd = result => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const newItemOrder = reorder(
        getList(source.droppableId),
        source.index,
        destination.index,
      );

      if (source.droppableId === 'droppable2') {
        setSelected(newItemOrder);
      } else {
        setItems(newItemOrder);
      }
    } else {
      const newResult = move(
        getList(source.droppableId),
        getList(destination.droppableId),
        source,
        destination,
      );

      setItems(newResult.droppable);
      setSelected(newResult.droppable2);
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-around',

        height: '100%',
      }}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <Card
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(draggableProvided, draggableSnapshot) => (
                    <Card
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      {...draggableProvided.dragHandleProps}
                      style={getItemStyle(
                        draggableSnapshot.isDragging,
                        draggableProvided.draggableProps.style,
                      )}
                    >
                      {item.content}
                    </Card>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Card>
          )}
        </Droppable>
        <Droppable droppableId="droppable2">
          {(provided, snapshot) => (
            <Card
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {selected.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(draggableProvided, draggableSnapshot) => (
                    <Card
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      {...draggableProvided.dragHandleProps}
                      style={getItemStyle(
                        draggableSnapshot.isDragging,
                        draggableProvided.draggableProps.style,
                      )}
                    >
                      {item.content}
                    </Card>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Card>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default Map;
